<template>
    <el-scrollbar style="height: 100%">
        <div class="slide-bar-wrap">
            <el-menu
                ref="menu"
                :default-active="$route.path"
                :collapse="isCollapse"
                class="left-menu"
                @select="handleSelectMenu"
                @open="handleOpenMenu"
                unique-opened
            >
                <template v-for="item in menuList">
                    <el-menu-item
                        v-if="!item.child || item.is_category == 1"
                        :key="item.id"
                        :index="item.url"
                        style="padding-left: 20px"
                        @click="clickMenu(item)"
                    >
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.name }}</span>
                        <el-badge
                            v-if="item.badge"
                            :value="item.badge"
                            :max="9999"
                            class="item"
                            type="info"
                        ></el-badge>
                    </el-menu-item>
                    <el-submenu
                        v-else
                        :key="item.id"
                        :index="item.id"
                        class="main-menu-submenu"
                    >
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span>{{ item.name }}</span>
                            <el-badge
                                v-if="item.badge"
                                :value="item.badge"
                                :max="9999"
                                class="item"
                                type="info"
                            ></el-badge>
                        </template>
                        <template v-for="second in item.child">
                            <el-menu-item
                                v-if="!second.child"
                                :key="second.id"
                                :index="second.url"
                                style="padding-left: 44px"
                                >{{ second.name }}</el-menu-item
                            >
                            <el-submenu
                                v-else
                                :key="second.id"
                                :index="second.url"
                            >
                                <template slot="title">{{
                                    second.name
                                }}</template>
                                <el-menu-item
                                    :index="third.url"
                                    v-for="third in second"
                                    :key="third.id"
                                    style="padding-left: 68px"
                                    >{{ third.name }}</el-menu-item
                                >
                            </el-submenu>
                        </template>
                    </el-submenu>
                </template>
            </el-menu>
        </div>
        <div class="slide-bar-footer">Custom Made Offer to win</div>
    </el-scrollbar>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            openedMenuIndex: null,
        };
    },
    computed: {
        ...mapState({
            menuList: (state) => state.login.menuList,
            menuDrawer: (state) => state.index.menuDrawer,
            isCollapse: (state) => state.index.isCollapse,
        }),
    },

    methods: {
        clickMenu(item){
            let visible = !this.menuDrawer.visible;
            // if(item.name === "Help Center"){
            //     return window.open(item.url, '_blank');
            // }else{
            if(item.name === "System"){
                this.$store.commit("SETMENUDRAWERVISIBLE", { visible, id: item.id });
            }else{
                this.$store.commit("SETMENUDRAWERVISIBLE", { visible: false, id: item.id });
            }
            this.$refs.menu.close(this.openedMenuIndex);
            // }
            
        },
        /**
         * 收起还是展开
         */
        handleChangeCollapse() {
            this.isCollapse = !this.isCollapse;
            this.$store.commit("INDEX_COLLAPSE", this.isCollapse);
        },
        handleOpenMenu(index, indexPath){
            this.openedMenuIndex = index;
            // 菜单展开, 关闭系统菜单
            this.menuDrawer.visible && this.$store.commit("SETMENUDRAWERVISIBLE", { visible: false, id: null });
        },
        handleSelectMenu(index, indexPath) {
            if (index.startsWith('http://') || index.startsWith('https://')) {
                return window.open(index);
            }

            this.$store.commit("SETMENUDRAWERVISIBLE", false);

            if (index !== this.$route.path) {
                this.$store.commit("MENUBREAD", []);
            }
            for (let i in this.menuList) {
                if (indexPath[0] == this.menuList[i].id) {
                    for (let j in this.menuList[i].child) {
                        if (index == this.menuList[i].child[j].url) {
                            this.$store.state.menu.menu_id = this.menuList[i].child[j].id;
                            localStorage.setItem(
                                "menu_id",
                                this.$store.state.menu.menu_id
                            );
                            this.$store.dispatch("getMenuAuth");
                        }
                    }
                }
            }
            if (event.metaKey || event.ctrlKey) {
                this.$router.push(index);
                let routeData = this.$router.resolve({ path: index });
                window.open(routeData.href, "_blank");
                setTimeout(() => {
                    this.$router.go(-1);
                }, 100);
            } else {
                this.$router.push(index);
            }
        },
    },
};
</script>
<style lang="scss">
.slide-bar-wrap {
    width: 200px;
    padding: 0 0 60px 0;
    .el-menu-item:hover,
    .el-menu-item:focus {
        background: $background-color-base;
    }
    .left-menu {
        width: 100%;
        background: $background-color-base;
    }
    .el-menu-item,
    .el-submenu__title {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: 700;
        background: $background-color-base;
        color: $color-text-regular;

        &.is-active {
            color: $color-primary;
            background: $menu-color-active;
        }

        &:hover {
            color: $color-primary;
            .iconfont,
            .elicon, .el-icon-collection {
                color: $color-primary;
            }
            background: $menu-color-active;
        }
        .el-badge.item {
            float: right;
            vertical-align: baseline;
            top: 6px;
            sup.el-badge__content--info {
                border: 0;
                font-weight: lighter;
                background: #e4e5e7;
                color: $color-text-regular;
            }
        }
        i {
            color: $color-text-regular;
            padding-right: 10px;
            font-size: 14px;
            box-sizing: border-box;
            margin-right: 0;
        }

        .el-submenu__icon-arrow.el-icon-arrow-down {
            // top: 22px;
            display: none;
        }
    }
    .el-submenu {
        text-align: left;
        .el-menu-item {
            height: 40px;
            line-height: 40px;
            font-size: 12px;
        }
        .is-active {
            background: $menu-color-active;
            // font-weight: bold;
        }
    }
    .el-submenu [class^="el-icon-"] {
        font-size: 14px;
    }
}

.slide-bar-footer {
    position: absolute;
    bottom: 10px;
    font-size: 12px;
    text-align: center;
    width: 100%;
    border-top: 1px solid #ddd;
    line-height: 44px;
    color: #999;
    background: #f6f6f7;
}
</style>
